<template>
  <div class="personalInfo">
    <Nav></Nav>
    <div class="top-img">
      <img :src="jjtd" alt=""/>
    </div>
    <div class="personal-info">
      <div class="info-wrap">
        <div class="info-left">
          <h2>{{ info.name }} <span class="position">{{ info.position }}</span></h2>
          <div class="base-info">
            <div class="info-item" v-if="info.phone">
              <img :src="tel" alt="电话图标" class="icon">
              <span>联系电话：{{ info.phone }}</span>
            </div>
            <div class="info-item" v-if="info.language">
              <img :src="net" alt="语言图标" class="icon">
              <span>工作语言：{{ info.language }}</span>
            </div>
            <div class="info-item" v-if="info.year">
              <img :src="year" alt="年限图标" class="icon">
              <span>执业年限：{{ info.year }}年</span>
            </div>
            <div class="info-item" v-if="info.educationalBackground">
              <img :src="education" alt="教育图标" class="icon">
              <span>教育背景：{{ info.educationalBackground }}</span>
            </div>
          </div>
          <div class="title-warp">
            <div class="section" v-if="info.careerField">
              <h3>执业领域</h3>
              <p>{{ info.careerField }}</p>
            </div>
            <div class="section" v-if="info.professionalQualification">
              <h3>职业资格</h3>
              <p>{{ info.professionalQualification }}</p>
            </div>
          </div>
          <div class="section" v-if="info.personalProfile">
            <h3>个人简介</h3>
            <p>{{ info.personalProfile }}</p>
          </div>
          <div class="section" v-if="info.socialAppointment">
            <h3>社会任职</h3>
            <p>{{ info.socialAppointment }}</p>
          </div>
          <div class="section" v-if="info.honors">
            <h3>所获荣誉</h3>
            <p>{{ info.honors }}</p>
          </div>
        </div>
        <div class="info-right">
          <img :src="info.imgPersonal" alt="个人照片" class="personal-img">
          <p class="license" v-if="info.code">执业证号：{{ formatLicense(info.code) }}</p>
          <!-- 下一篇文本：有下一篇时可点击，无则显示“已是最后一篇” -->
          <p
              class="nextPage"
              @click="nextPage"
              :style="{ cursor: nextName ? 'pointer' : 'default' }"
          >
            下一篇：{{ nextName || '已是最后一篇' }}
            <span v-if="nextName">→</span>
          </p>
        </div>
      </div>
    </div>
    <footer-con/>
  </div>
</template>

<script>
import Nav from "@/components/nav";
import FooterCon from '@/components/footer-con'
import jjtd from '@/assets/img/jjtd.png'
import net from '@/assets/img/net.png'
import tel from '@/assets/img/phone.png';
import education from '@/assets/img/edu.png';
import year from '@/assets/img/year.png';
import dataList from './data'

export default {
  name: "PersonalInfo",
  components: {
    Nav,
    FooterCon,
  },
  data() {
    return {
      info: {},
      jjtd,
      net,
      tel,
      education,
      year,
      dataList,
      nextName: '', // 下一篇名称
      currentIndex: -1 // 当前数据在dataList中的索引（关键：用于切换数据）
    };
  },
  mounted() {
    const targetId = this.$route.query.id;
    // 找到当前数据的索引和详情
    this.currentIndex = this.dataList.findIndex(item => item.id == targetId);
    this.info = this.currentIndex !== -1 ? this.dataList[this.currentIndex] : {};
    this.updateNextName();
  },
  methods: {
    // 格式化执业证号
    formatLicense(license) {
      if (!license) return '';
      const start = license.substring(0, 10);
      const end = license.substring(license.length - 4);
      const middle = '*'.repeat(license.length - 14);
      return `${start}${middle}${end}`;
    },

    // 更新“下一篇”名称（复用逻辑）
    updateNextName() {
      // 若不是最后一条数据，显示下一篇名称；否则显示空
      if (this.currentIndex !== -1 && this.currentIndex < this.dataList.length - 1) {
        this.nextName = this.dataList[this.currentIndex + 1].name;
      } else {
        this.nextName = '';
      }
    },

    // 下一篇：直接更新当前页面数据（不跳转路由）
    nextPage() {
      // 先判断是否有下一篇
      if (this.currentIndex >= this.dataList.length - 1) return;

      this.currentIndex += 1;
      this.info = this.dataList[this.currentIndex];
      this.updateNextName();

      // （可选）滚动到页面顶部，提升体验
      window.scrollTo({ top: 0, behavior: 'smooth' });
    }
  }
};
</script>


<style lang="scss" scoped>
.top-img {
  width: 100%;
  img {
    width: 100%;
    vertical-align: top;
  }
}

.personal-info {
  width: 100%;
  padding: 10vh 10vw;
  box-sizing: border-box;
  background-color: #fff;
}

.info-wrap {
  display: flex;
  gap: 5vw;
  margin: 0 auto;
}

.title-warp{
  display: flex;
  .section{
    width: 50%;
  }
}

.info-left {
  width: 70%;

  h2 {
    font-size: 32px;
    font-weight: 600;
    color: #333;
    margin-bottom: 30px;
    .position {
      font-size: 16px;
      font-weight: 400;
      color: #AD867E;
      margin-left: 24px;
    }
  }

  .base-info {
    display: flex;
    flex-wrap: wrap;
    gap: 20px 30px;
    margin-bottom: 40px;
    border-bottom: 1px solid #eee;
    padding-bottom: 20px;

    .info-item {
      display: flex;
      align-items: center;

      .icon {
        width: 24px;
        height: 24px;
        margin-right: 10px;
        object-fit: contain;
      }

      span {
        font-size: 14px;
        color: #666;
        line-height: 1.5;
      }
    }
  }

  .section {
    margin-bottom: 30px;

    h3 {
      font-size: 20px;
      font-weight: 500;
      color: #333;
      margin-bottom: 15px;
      position: relative;
    }

    p {
      font-size: 16px;
      color: #666;
      line-height: 26px;
      text-align: justify;
    }
  }
}

.info-right {
  width: 30%;
  display: flex;
  flex-direction: column;
  align-items: center;
  position: relative;

  .license {
    margin-top: 22px;
    font-size: 14px;
    color: #333;
    text-align: center;
  }
  .nextPage{
    font-size: 14px;
    color: #666666;
    margin-top: 30px;
    position: absolute;
    right: 20%;
    bottom: -40px;
  }
}

</style>
